import ContactDetails from "@/components/features/contact/ContactDetails/ContactDetails";
import { ContactNotFound } from "@/components/features/contact/ContactNotFound/ContactNotFound";
import { AppPageShell, GlobalNotAuthorized } from "@/components/ui";
import { GlobalErrorPage } from "@/components/ui/GlobalErrorPage/GlobalErrorPage";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { ErrorBoundary } from "@sentry/react";
import { createFileRoute } from "@tanstack/react-router";
import { AxiosError } from "axios";

export const Route = createFileRoute("/_auth/contacts/$contactId/")({
  component: RouteComponent,
  pendingComponent: () => (
    <div className="flex w-full">
      <LawWorksLoader className="w-full" />
    </div>
  ),
  notFoundComponent: () => {
    return <ContactNotFound />;
  },
  errorComponent: () => {
    return <GlobalErrorPage />;
  },
});

function RouteComponent() {
  const { contactId } = Route.useParams();

  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.contactsDetail)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <ErrorBoundary
      fallback={({ error }) => (
        <>
          {error instanceof AxiosError &&
          (error.status === 403 || error.status === 404) ? (
            <ContactNotFound />
          ) : (
            <GlobalErrorPage />
          )}
        </>
      )}
    >
      <AppPageShell padding="none" className="h-full min-h-0">
        <ContactDetails contactId={contactId} />
      </AppPageShell>
    </ErrorBoundary>
  );
}
